// import { GetEventResponseDto } from "@/api/event/dto";
// import { GetMyUpcomingReservationsDto } from "@/api/user/useGetMyUpcomingReservations";
import {
  GetEventResponseDto,
  GetMyUpcomingReservationsResponseDto,
} from "@/api/generated/generatedTypes";
import { formatReservationTime } from "@/utils/date";
import { Box, Button, Flex, Group, Stack, Text } from "@mantine/core";
import { NavLink } from "react-router-dom";
import { ReservationDetailItems } from "./ReservationDetailItems/ReservationDetailItems";
import { ReservationStatusLabelResolver } from "./ReservationStatusLabelResolver";

interface Props {
  reservation: GetMyUpcomingReservationsResponseDto;
  event: GetEventResponseDto;
  onBack: () => void;
  isPast?: boolean;
}

export function EventDetail({ reservation, onBack, event, isPast = false }: Props) {
  return (
    <Stack>
      <Box
        style={(theme) => ({
          backgroundColor: "#202f37",
          borderRadius: theme.radius.lg,
          padding: "1rem",
          border: "1px solid #555555",
        })}
      >
        <Stack gap="sm">
          <Group justify="space-between" align="center">
            <Group gap="md" align="center" wrap="nowrap">
              <ReservationStatusLabelResolver reservation={reservation} isPast={isPast} />
              <Stack gap={3}>
                <Text fw={500} c="white" size="clamp(0.8rem, 3.5vw, 1.2rem)">
                  {formatReservationTime(event.startTime)}
                </Text>
                {event.restaurant?.name && (
                  <Text fw={500} c="white" size="clamp(0.8rem, 3.5vw, 1.2rem)">
                    {event.restaurant.name}
                  </Text>
                )}
              </Stack>
            </Group>
          </Group>
          <Flex justify="end" gap="sm">
            {!isPast && (
              <Button
                component={NavLink}
                to={`/reservation-change/${reservation.id}`}
                style={(theme) => ({
                  borderRadius: theme.radius.lg,
                  backgroundColor: "#eae4e0",
                  color: theme.black,
                })}
              >
                예약 관리
              </Button>
            )}
          </Flex>
        </Stack>
      </Box>

      <ReservationDetailItems reservation={reservation} event={event} isPast={isPast} />
    </Stack>
  );
}
